var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineRouting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.49 9.96C1.65 8.21.91 6.3 1.34 4.43c.51-2.2 2.44-3.18 4.13-3.18s3.63.99 4.13 3.18c.43 1.87-.32 3.78-2.15 5.53-.55.53-1.26.79-1.98.79-.71 0-1.43-.26-1.98-.79zm1.04-1.09c.53.51 1.36.5 1.89 0 1-.95 2.11-2.43 1.72-4.11-.34-1.48-1.65-2.01-2.66-2.01-1.02 0-2.33.53-2.68 2.02-.38 1.67.73 3.15 1.73 4.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.51 5.2c0-.55.44-1 1-1h.01c.55 0 1 .45 1 1a1.005 1.005 0 0 1-2.01 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21.96c-1.85-1.75-2.6-3.66-2.16-5.54.51-2.19 2.45-3.18 4.15-3.18 1.7 0 3.64.99 4.15 3.18.43 1.87-.32 3.79-2.17 5.53-.55.54-1.26.8-1.98.8-.71 0-1.43-.26-1.99-.79zm-.7-5.19c-.39 1.67.73 3.16 1.73 4.11.53.51 1.37.51 1.91 0 1-.95 2.12-2.43 1.73-4.1-.33-1.5-1.65-2.03-2.68-2.03-1.02 0-2.34.53-2.69 2.02z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.53 17.2c0-.55.44-1 1-1h.01c.55 0 1 .45 1 1s-.46 1-1.01 1-1-.45-1-1zM9.32 19.75c-1.16 0-2.17-.7-2.57-1.78-.41-1.08-.11-2.27.76-3.04l7.99-6.99c.48-.42.49-.99.35-1.38-.15-.39-.53-.81-1.17-.81H12c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.68c1.16 0 2.17.7 2.57 1.78.41 1.08.11 2.27-.76 3.04L8.5 16.06c-.48.42-.49.99-.35 1.38.15.39.53.81 1.17.81H12c.41 0 .75.34.75.75s-.34.75-.75.75H9.32z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.32 19.75c-1.16 0-2.17-.7-2.57-1.78-.41-1.08-.11-2.27.76-3.04l7.99-6.99c.48-.42.49-.99.35-1.38-.15-.39-.53-.81-1.17-.81H12c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.68c1.16 0 2.17.7 2.57 1.78.41 1.08.11 2.27-.76 3.04L8.5 16.06c-.48.42-.49.99-.35 1.38.15.39.53.81 1.17.81H12c.41 0 .75.34.75.75s-.34.75-.75.75H9.32z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRouting);
export default __webpack_public_path__ + "static/media/vuesax-outline-routing.5ed3edc185b5a1a94ee9235fe1e983ea.svg";
export { ForwardRef as ReactComponent };